export default __webpack_public_path__ + "static/Entenda0033-0cb6d6cb989704855bd9b70450b338c3.jpg";